import { render, staticRenderFns } from "./OrderCashback.vue?vue&type=template&id=650a4378&scoped=true&"
import script from "./OrderCashback.vue?vue&type=script&lang=js&"
export * from "./OrderCashback.vue?vue&type=script&lang=js&"
import style0 from "./OrderCashback.vue?vue&type=style&index=0&id=650a4378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650a4378",
  null
  
)

export default component.exports